import React from 'react'

import { FlatList, FlatListProps } from 'widgets/FlatList'

import { Subscription } from 'types/subscription'

import { UpspaceChatRow } from './subcomponents/UpspaceChatRow'

type Props = Omit<FlatListProps<Subscription>, 'renderItem'>

export const UpspaceChatList = ({ data, loading, onEndReached, ...rest }: Props) => (
  <FlatList<Subscription>
    data={data}
    keyExtractor={(subscription) => `${subscription.id}`}
    loading={loading}
    noContentProps={{
      message: "You don't have any Group chats yet.",
    }}
    onEndReached={onEndReached}
    renderItem={({ item: subscription }) => <UpspaceChatRow subscription={subscription} />}
    {...rest}
  />
)
